import type { Step } from '@de/types/types';

/**
 * Read the normalized step-level flow type used by DSL context, conversion
 * creation, and governed lead-flow wiring.
 */
export function readStepFlowType(step?: Step): string | undefined {
  const value = step?.flowType;
  return typeof value === 'string' && value.trim() ? value : undefined;
}
